export { PRIVACY_POLICY_URL, SUPPORT_CONTACT_URL } from '../cpf-validation/constants'

export const IMAGE_MAX_SIZE_BYTES = 10 * 1024 * 1024

export const ACCEPTED_IMAGE_INPUT = '.jpg,.jpeg,.png,image/jpeg,image/png'
